export type PortfolioMediaType = 'gallery' | 'video';
export type VideoPlatform = 'youtube' | 'instagram' | 'tiktok' | 'facebook';

export const PLATFORM_LABELS: Record<VideoPlatform, string> = {
  youtube: 'YouTube',
  instagram: 'Instagram',
  tiktok: 'TikTok',
  facebook: 'Facebook',
};

export const PLATFORM_WATCH_LABELS: Record<VideoPlatform, string> = {
  youtube: 'Voir sur YouTube',
  instagram: 'Voir sur Instagram',
  tiktok: 'Voir sur TikTok',
  facebook: 'Voir sur Facebook',
};

export function detectVideoPlatform(url: string): VideoPlatform | null {
  const lower = url.toLowerCase();
  if (lower.includes('youtube.com') || lower.includes('youtu.be')) return 'youtube';
  if (lower.includes('instagram.com')) return 'instagram';
  if (lower.includes('tiktok.com')) return 'tiktok';
  if (lower.includes('facebook.com') || lower.includes('fb.watch')) return 'facebook';
  return null;
}

export function isVideoProject(item: { mediaType?: PortfolioMediaType; videoUrl?: string | null }): boolean {
  return item.mediaType === 'video' || Boolean(item.videoUrl);
}

export function resolvePlatform(
  platform?: VideoPlatform | null,
  videoUrl?: string | null,
): VideoPlatform | null {
  if (platform) return platform;
  if (videoUrl) return detectVideoPlatform(videoUrl);
  return null;
}
